import classes from "../homePageNew.module.css";

const RADIUS = 15.9155;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

/**
 * Small circular progress ring for a single 0-100 score (e.g. a record's
 * overall Brand Index Score on its list card) — generic, takes a plain
 * `score` number so any future module's card can reuse it for its own
 * top-line metric. Distinct from ScoreDonut, which is the larger multi-
 * segment breakdown used in the detail pane/drawer.
 */
export default function MiniScoreRing({ score, size = 32 }) {
  const hasScore = score != null;
  const pct = hasScore ? Math.min(100, Math.max(0, score)) : 0;
  const offset = CIRCUMFERENCE - (pct / 100) * CIRCUMFERENCE;

  return (
    <div className={classes.miniRing} style={{ width: size, height: size }} title={hasScore ? `Brand Index Score: ${score}/100` : "Score not available"}>
      <svg viewBox="0 0 36 36" className={classes.miniRingSvg}>
        <circle cx="18" cy="18" r={RADIUS} className={classes.miniRingTrack} />
        {hasScore && (
          <circle
            cx="18"
            cy="18"
            r={RADIUS}
            className={classes.miniRingProgress}
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={offset}
          />
        )}
      </svg>
      <span className={classes.miniRingValue}>{hasScore ? score : "—"}</span>
    </div>
  );
}
